import templateUrl from './emptyTaskTemplates.html';

export default { templateUrl };
